import React from "react";
import { Box, Button } from "@mui/joy";
import { theme } from "../../styles/theme";

export function BottomNextButtonPromotion({
  disabled,
  onClick,
  text,
  highlightBackground,
  loading = false,
  isInputFocused = false,
  focusOffset = 56,
}: {
  disabled: boolean;
  onClick: () => void;
  text: string;
  highlightBackground?: boolean;
  loading?: boolean;
  isInputFocused?: boolean;
  focusOffset?: number; // px to lift the button when keyboard is shown
}) {
  return (
    <Box
      sx={{
        // 화면 하단에 고정
        position: "fixed",
        left: 0,
        bottom: isInputFocused ? `${focusOffset}px` : 0,
        width: "100%",
        zIndex: 1200,
        background: !highlightBackground // TODO 리팩토링
          ? `linear-gradient(180deg, rgba(246, 249, 250, 0) 0%, ${theme.vars.palette.Background.Level1} 20%)`
          : `background: linear-gradient(180deg, rgba(220, 239, 250, 0) 0%, ${theme.vars.palette.Background.Level1} 20%)`,
        // background: linear-gradient(180deg, rgba(220, 239, 250, 0) 0%, #DCEFFA 20%);

        // TODO home indicator 있는 경우 고려
        px: "20px",
        py: 2,
        display: 'flex', // flexbox 사용
        justifyContent: 'center', // 가로 가운데 정렬
        transition: 'bottom 0.2s ease',
      }}
    >
      <Button
        loading={loading}
        variant={"Action"}
        size={"lg"}
        sx={{
          maxWidth: "620px",
          width: "100%",
        }}
        disabled={disabled}
        onClick={onClick}
      >
        {text}
      </Button>
    </Box>
  );
}